/**
 * Cordova Vuex Store Module State
 * @property {string} cordovaStatus - current cordova state
 */
export const state = {
  // Needed for backward compatibility. Capacitor does not need to wait for the "ready" state https://capacitorjs.com/docs/cordova#plugin-management.
  cordovaStatus:  'ready',
  cordovaVersion: 'capacitor',
  device:         {},
};

/**
 * Cordova Vuex Store Module Getters
 * @property {boolean} isCordovaReady - provide info if cordova loaded
 */
export const getters = {
  isCordovaReady: state => state.cordovaStatus === 'ready',
  version:        state => state.cordovaVersion,
  deviceInfo:     state => state.device,
};

export default {
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/apps/cordova/store/state.js